import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { useAnimation } from '@angular/animations';
import { SharedModule } from '../../shared/shared.module';
import { UserRoutingModule } from './user-routing.module';

@NgModule({
  declarations: [
    UserManagementComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UserRoutingModule,
  ],
  exports: [
    UserManagementComponent
  ],
})
export class UserModule { }
